import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";

import SubProfileWizard from 'views/Profiles/SubProfileWizard/SubProfileWizard'
import ProfileWizard from 'views/Profiles/Wizard/ProfileWizard'
import List from 'views/Profiles/List'
import SpecialCase from 'views/Profiles/SpecialCase'


class Profiles extends React.Component {
  render() {
    const {match}=this.props;
    return (
      
          <Switch>
            <Route exact path={`${match.path}/add`} component={ProfileWizard}/>
            <Route exact path={`${match.path}/addDefault`} component={ProfileWizard}/>
            <Route exact path={`${match.path}/specialcases/:id`} component={SpecialCase}/>
            <Route exact path={`${match.path}/:id`} component={ProfileWizard}/>
            {/* <Route exact path={`${match.path}/:profileId/subprofile/add`} component={SubProfileWizard}/> */}
            <Route exact path={`${match.path}/:profileId/ib/:ibId/subprofile/:id`} component={SubProfileWizard}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Profiles);



// WEBPACK FOOTER //
// ./src/views/Profiles/Profiles.jsx